export default "__VITE_ASSET__VRlS5T70__"